module.exports = __webpack_public_path__ + "static/media/1005866.d4daefc9.jpg";